import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

//Hilfsfunktion: Aufgeloeste URL inkl. Query-Parameter erstellen
function getResolvedUrl(route: ActivatedRouteSnapshot): string {
    let url = route.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/');
    const queryParam = route.queryParamMap;
    if (queryParam.keys.length > 0) {
        url += '?' + queryParam.keys.map(key => queryParam.getAll(key).map(value => key + '=' + value).join('&')).join('&');
    }
    return url;
}

/**
 * Funktionaler Guard zum Schutz von Routen basierend auf Authentifizierung und Rollen.
 *
 * Prueft ob der Benutzer angemeldet ist und die fuer die Route erforderlichen Rollen besitzt.
 * Bei fehlender Berechtigung wird auf die Startseite weitergeleitet,
 * bei fehlender Anmeldung wird der OAuth-Login-Flow gestartet.
 */
export const authGuard: CanActivateFn = (route): Observable<boolean> => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.isDoneLoading$.pipe(map((_) => {
        const claims = authService.claims;
        if (claims !== undefined && authService.hasValidAccessToken()) {
            const userRoles = authService.claims.groups as string[];
            if (userRoles !== null) {
                const allowedRoles: string[] = route.data['roles'] as string[];
                const matchingRoles: string[] = userRoles.filter((x) => allowedRoles.includes(x));
                if (matchingRoles.length > 0) {
                    const allowedUsers: string[] = route.data['users'] as string[];
                    if (allowedUsers && allowedUsers.length > 0) {
                        const userProfileData = authService.getUserProfileData();
                        if (!userProfileData || !allowedUsers.includes(userProfileData.email)) {
                            router.navigate(['/']);
                            return false;
                        }
                    }
                    return true;
                } else {
                    router.navigate(['/']);
                    return false;
                }
            }
            return false;
        } else {
            const redirectUri = getResolvedUrl(route);
            authService.loginWithRedirect(redirectUri);
            return false;
        }
    }));
};
